/**
 * @Author: Zewei
 * @Date:   2018-02-01T10:34:25+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-27T16:56:22+08:00
 */
 import { AnnouncementConstants } from '../constants/announcement-constants.js';

 const initState = {
     announcementList: {
		filters: {
			page: 1
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
 }

 export default function announcement (state = initState, action) {
   switch (action.type) {
      // 制度公告
      case AnnouncementConstants.ActionTypes.CHANGEANNOUNCEMENT:
			return {
				...state,
				announcementList: {
					...state.announcementList,
					filters: {
						...state.announcementList.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.announcementList.loadCounter + action.payload.counter
				}
			}

		case AnnouncementConstants.ActionTypes.SELECTANNOUNCEMENT:
			return {
				...state,
				announcementList: {
					...state.announcementList,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}
		case AnnouncementConstants.ActionTypes.UPDATEANNOUNCEMENT:
			return {
				...state,
				announcementList: {
					...state.announcementList,
					data: {
						...state.announcementList.data,
						Data: [
							...state.announcementList.data.Data.slice(0, action.payload.index),
							action.payload.data,
							...state.announcementList.data.Data.slice(action.payload.index + 1)
						]
					}
				}
			}
      default:
          return {...state};
   }
 }



// WEBPACK FOOTER //
// ./src/reducers/announcement-reducer.js